import React, { useMemo } from 'react';
import { Phone, ArrowRight, CheckCircle } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ruonn-replica/artifacts/652j8z6m_logo%20letra%20transparente%20white.png';

const CTASection = ({ onOpenModal }) => {
  // Dynamic spots calculation
  const spotsLeft = useMemo(() => {
    const now = new Date();
    const dayOfMonth = now.getDate();
    return ((dayOfMonth * 11) % 4) + 2; // Results in 2, 3, 4, or 5
  }, []);

  return (
    <section className="bg-[#0a0a0b] py-24 px-6">
      <div className="max-w-4xl mx-auto">
        {/* CTA Card */}
        <div className="relative rounded-3xl bg-gradient-to-br from-purple-900/30 via-[#1a1a1f] to-[#1a1a1f] border border-purple-500/20 p-12 md:p-16 text-center overflow-hidden">
          {/* Background decorations */}
          <div className="absolute top-0 left-0 w-60 h-60 bg-purple-600/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-600/10 rounded-full blur-3xl" />
          
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src={LOGO_URL} 
              alt="Ruonn" 
              className="h-8 w-auto opacity-50"
            />
          </div>

          {/* Content */}
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-500/10 border border-green-500/20 text-sm text-green-400 mb-6">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              Limited availability - {spotsLeft} spots left
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white font-normal mb-4">
              Your dream team is <span className="italic font-light">one call away.</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
              Join 500+ companies that scaled faster with Ruonn. Get matched with top talent in 72 hours.
            </p>

            {/* Value props */}
            <div className="flex flex-wrap justify-center gap-6 mb-10">
              <div className="flex items-center gap-2 text-gray-300">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Top 3% vetted talent</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>72-hour matching</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span>Full replacement guarantee</span>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={onOpenModal}
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white px-10 py-5 rounded-full text-lg font-medium transition-all duration-300 hover:scale-105 shadow-xl shadow-purple-500/30"
            >
              <Phone className="w-5 h-5" />
              Get Your Free Consultation
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            
            <p className="text-gray-500 text-sm mt-6">
              No credit card required • Response within 24 hours
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
